module.exports = __webpack_public_path__ + "static/media/Like the Morning.ce238ebb.jpg";